module.exports = __webpack_public_path__ + "4acff15898df7a32851b004e312a817b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/glasses-reading.png
// module id = 1832
// module chunks = 0